export default "__VITE_ASSET__BgOuSx92__"